import { useCallback, useEffect, useState } from "react";
import { PLANNING_STATES } from "../../../classes/enums/PlanningStateEnum";
import "./ValidationOverlayTools.css";

const LEGEND_ITEMS = [
  {
    key: "UPPER_ENDPLATES",
    label: "Upper Endplates",
    color: "#0082A9",
  },
  {
    key: "LOWER_ENDPLATES",
    label: "Lower Endplates",
    color: "#40C72A",
  },
  {
    key: "PEDICLES_LEFT",
    label: "Left Pedicle Points",
    color: "#F58331",
  },
  {
    key: "PEDICLES_RIGHT",
    label: "Right Pedicle Points",
    color: "#FFF42F",
  },
];

const buildDefaultState = () =>
  LEGEND_ITEMS.reduce((acc, item) => {
    acc[item.key] = true;
    return acc;
  }, {});

const ValidationOverlayTools = ({
  remoteRenderClient,
  viewReloadToken = 0,
  disabled = false,
}) => {
  const [activeStates, setActiveStates] = useState(buildDefaultState);

  useEffect(() => {
    const initialState = buildDefaultState();
    setActiveStates(initialState);
    if (!remoteRenderClient || disabled) {
      return;
    }
    remoteRenderClient
      .setValidationToolComponentsVisibility(
        PLANNING_STATES.VALIDATE,
        initialState
      )
      .catch(error => {});
  }, [remoteRenderClient, viewReloadToken, disabled]);

  const toggleLegendItem = useCallback(
    async key => {
      if (!remoteRenderClient || disabled) {
        return;
      }

      setActiveStates(prev => {
        const previousValue = prev[key];
        const updatedStates = {
          ...prev,
          [key]: !previousValue,
        };

        remoteRenderClient
          .setValidationToolComponentsVisibility(
            PLANNING_STATES.VALIDATE,
            updatedStates
          )
          .catch(error => {
            setActiveStates(current => ({ ...current, [key]: previousValue }));
          });

        return updatedStates;
      });
    },
    [remoteRenderClient, disabled]
  );

  return (
    <div
      className="Validation-overlay-tools-container"
      style={disabled ? { pointerEvents: "none", opacity: 0.5 } : undefined}
    >
      {LEGEND_ITEMS.map(item => (
        <div className="Validation-overlay-tool" key={item.key}>
          <div
            className={`Validation-overlay-option App-text-small ${
              disabled ? "disabled" : ""
            }`}
            onClick={() => {
              if (!disabled) {
                toggleLegendItem(item.key);
              }
            }}
          >
            <div
              className={`Validation-option-circle ${
                activeStates[item.key] ? "active" : ""
              }`}
              style={{
                borderColor: item.color,
                backgroundColor: activeStates[item.key]
                  ? item.color
                  : "transparent",
              }}
            />
            <div className={"App-text-small"} style={{ color: item.color }}>
              {item.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationOverlayTools;
